import { takeLatest, call, put } from 'redux-saga/effects';
import config from 'config';
import * as http from 'utils/http';
import serialize from 'utils/serialize';

import { setData, setLoading, setResetData, setPlainData } from './duck';
import { groupJourneyData } from 'redux/modules/journeys/utils';
import { computeJourneys } from 'redux/modules/journeys/computed';

const normalize = (data) => new Map(data.map((so) => [so.id, so]));

// @effect Action
const listMounted$ = 'driverJourneysList/listMounted$';
const listUnMounted$ = 'driverJourneysList/listUnMounted$';

// @effect Creators
export const listMounted = ({ driverId }) => ({
  type: listMounted$,
  payload: { driverId },
});

export const listUnMounted = () => ({
  type: listUnMounted$,
});

const adaptFiltersForBackend = (filters) => {
  const { driverId } = filters;

  return {
    transit_status: 'in_transit',
    page_size: 0,
    driver: driverId,
  };
};

function* handleDataRequest(filters) {
  yield put(setLoading(true));
  const backendFilters = yield call(adaptFiltersForBackend, filters);
  const queryStr = yield call(serialize, backendFilters);

  try {
    const response = yield call(http.get, `${config.API_URL}mercury/journeys/?${queryStr}`);
    const computedJourneys = yield call(computeJourneys, response);
    const normalizedJourneys = yield call(normalize, computedJourneys);

    const groupedJourneys = yield call(groupJourneyData, computedJourneys, {
      groupingField: 'start_time_from',
    });

    yield put(setPlainData(normalizedJourneys));
    yield put(setData(groupedJourneys));
  } catch (err) {
    console.error(err);
  } finally {
    yield put(setLoading(false));
  }
}

function* handleListMounted({ payload }) {
  yield call(handleDataRequest, payload);
}

function* handleListUnMounted() {
  yield put(setResetData());
}

// Watchers
export function* watchDriverJourneys() {
  yield takeLatest(listMounted$, handleListMounted);
  yield takeLatest(listUnMounted$, handleListUnMounted);
}
